import { Table } from "reactstrap";
import '../../../components/Globals.css'
import { useSelector } from "react-redux";
import TableComponent from "../../../components/Table";



const StickyIECHeadTable = () => {
    const { storeIecInfoData = {} } = useSelector((state: any) => state.iecActivity || {});
    const tableHeadersList = [
        "IEC ID",
        "State",
        "District",
        "Block",
        "Type of Activity",
        "Name",
        "Date",
    ]
    return (
        <div>
            <TableComponent tableHeadersList={tableHeadersList} data={storeIecInfoData} />
        </div>
    );
};

export default StickyIECHeadTable;
